export function validateMasterNewChargeForm(masterNewChargeForm){
  const { payment_source, transaction_type, first_issue_date, first_due_date, ends_at, interval_count, interval, end_type, occurrences, 
          has_credit_card_to_charge, did_the_client_already_pay, already_paid_payment_method, invoice_client, 
          email, amount, memo, due_date, send_email_number_of_days_before_due_date, group_id } = masterNewChargeForm

  const validate_recurring_schedule = () => (
    transaction_type != 'recurring' || (
      transaction_type == 'recurring' && 
      (( has_credit_card_to_charge == 'no' && !!first_due_date ) ||
      ( has_credit_card_to_charge == 'yes' && !!first_due_date )) &&
      !!interval_count &&
      !!interval &&
      !!end_type &&
      ( 
        !end_type ||
        end_type == 'never' ||
        (end_type == 'on_date' && !!ends_at) ||
        (end_type == 'number_of_occurrences' && !!occurrences)
      )
    )
  )

  const validate_credit_card_to_charge = () => (
    has_credit_card_to_charge == 'no' || (
      has_credit_card_to_charge == 'yes' &&
      !!payment_source 
    )
  )

  const validate_already_paid = () => (
    has_credit_card_to_charge == 'yes' || (
      has_credit_card_to_charge == 'no' &&
      did_the_client_already_pay == 'no' || (
        did_the_client_already_pay == 'yes' &&
        !!already_paid_payment_method
      )
    )
  )

  const validate_invoicing = () => {
    // for a single charge.
    if (transaction_type == 'single'){
      return (
        has_credit_card_to_charge == 'yes' || (
          has_credit_card_to_charge == 'no' && (
            (did_the_client_already_pay == 'no' && 
            !!due_date && (
              invoice_client == 'no' || (
                invoice_client == 'yes' &&
                !!email
              )
            ) || (
                (
                  did_the_client_already_pay == 'yes' && (
                    invoice_client == 'no' || (
                      invoice_client == 'yes' &&
                      !!email
                    )
                  )
                )
              )
            )
          )
        )
      )
      // for recurring charges
    } else if (transaction_type == 'recurring'){
      return (
        has_credit_card_to_charge == 'yes' || (
          has_credit_card_to_charge == 'no' && 
          !!first_due_date &&
          invoice_client == 'no' || (
            invoice_client == 'yes' &&
            !!email && !!first_issue_date
          )
        )
      )
    }
  }

  
  return (
    amount > 0 &&
    !!memo &&
    !!transaction_type && 
    validate_recurring_schedule() &&
    validate_credit_card_to_charge() &&
    validate_already_paid() &&
    validate_invoicing()
  )
}